export default __webpack_public_path__ + "static/media/thank-you-desktop.d7a3b9d8.jpg";